import React, {Component} from 'react';

class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    //console.log( this.props.data );
    //this.is_free = this.props.item.final_price===0;
    this.is_free = this.props.data.final_price===0;

    //console.log( this.props.data );

    this.rate_data = window.__discount_object.discountData(this.props.data.product_id, this.props.data.variant_id, window.__discount_object.quantity(this.props.data.handle,this.props.data.quantity) );
    //console.log( this.rate_data );
  };

  render() {
    if( this.is_free ) return null;

    return (
      <React.Fragment>
        { this.props.properties!==null && Object.keys(this.props.properties).map((data, i) => 
          <div key = {"properties_"+this.props.data.key+"_"+i} className="property">
            {(() => {
            if ( data.startsWith("_") ) {
              return null;
            }
            if ( data==="_pound" && this.rate_data!==null ) {
              return (
                <span>( {this.rate_data.price} / LB )</span>
              )
            }
            else if ( data.indexOf("_ocu_")===-1 && data.indexOf("_discount")===-1 ) {
              return (
                <React.Fragment>
                  {(() => {
                    if ( data!=="pre order" ) {
                      return (
                        <>
                          <span className="property_key">{data}: </span>
                          <span>{this.props.properties[data]}</span>
                        </>
                      )
                    }
                  })()}
                </React.Fragment>
              )
            }
            
            })()}
          </div>
        )}
        {/*<FreeWax data={this.props.data}/>*/}
      </React.Fragment>
    )
  };
}

export default Container;